import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const MentionsLegalesPage = () => {
  return (
    <MainLayout>
      <div className="container mx-auto py-8 px-4">
        <h1 className="text-3xl font-bold text-center mb-8">Mentions Légales</h1>
        
        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle>Informations légales</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">Éditeur du site</h2>
              <p className="text-muted-foreground">
                NautiCoach<br />
                Entreprise individuelle<br />
                525 rue Marc Delage<br />
                83130 La Garde<br />
                Tél : 06 61 67 59 37<br />
                Email : <a href="mailto:contact@nauticoach.com" className="text-primary underline">contact@nauticoach.com</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Directeur de la publication</h2>
              <p className="text-muted-foreground">
                [Nom et prénom du directeur de publication]
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Hébergement</h2>
              <p className="text-muted-foreground">
                Ce site est hébergé par :<br />
                Supabase Inc. (infrastructure AWS – région EU-West, Irlande/Francfort)<br />
                970 Toa Payoh North, #07-04, Singapore 318992<br />
                Site : <a href="https://supabase.com" target="_blank" rel="noopener noreferrer" className="text-primary underline">supabase.com</a>
              </p>
              <p className="text-muted-foreground mt-2">
                Le front-end est distribué par :<br />
                Lovable (GPT Engineer Inc.)<br />
                Site : <a href="https://lovable.dev" target="_blank" rel="noopener noreferrer" className="text-primary underline">lovable.dev</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Propriété intellectuelle</h2>
              <p className="text-muted-foreground">
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Responsabilité</h2>
              <p className="text-muted-foreground">
                Les informations contenues sur ce site sont aussi précises que possible et le site remis à jour à différentes périodes de l'année, mais peut toutefois contenir des inexactitudes ou des omissions.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default MentionsLegalesPage;